import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, Router } from "@angular/router";

import { handleRoutePermission } from "../../../core/guards/guards-util";
import { PermissionAction } from "../../../shared/constants/enums";
import { ActivitiesService } from "../../../shared/services";

export const activityTypeViewAccessGuard = (state: ActivatedRouteSnapshot) => {
  const activityType = state.params["activityType"];
  return getActivityPermissionGuard(activityType, PermissionAction.view);
};

export const activityTypeEditAccessGuard = (state: ActivatedRouteSnapshot) => {
  const activityType = state.params["activityType"];
  return getActivityPermissionGuard(activityType, PermissionAction.manage);
};

const getActivityPermissionGuard = (activityType: string, permissionAction: PermissionAction) => {
  const activitiesService = inject(ActivitiesService);
  const router = inject(Router);

  const permissionId = activitiesService.getPermission(activitiesService.getActivityTypeId(activityType) ?? 0);

  if (!permissionId) {
    return router.createUrlTree(["/console/activity"]);
  }

  return handleRoutePermission({
    actor: {
      modifier: "and",
      permissions: [
        {
          permissionAction: permissionAction,
          objectTypeId: permissionId,
        },
      ],
    },
  });
};
